<template>
  <el-dialog
    append-to-body
    title="测水完成"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="测水结果" prop="microwave_moisture">
        <el-input
          v-model.trim="form.microwave_moisture"
          placeholder="请输入测水结果"
          class="w-80"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="测量时间" prop="measure_time">
        <el-date-picker
          v-model="form.measure_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择测量时间"
          class="w-full"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dialogVisible: false,
      form: this.getDefaultForm(),
      rules: {
        microwave_moisture: [
          { required: true, message: "请输入测水结果", trigger: "blur" }
        ],
        measure_time: [
          { required: true, message: "请选择测量时间", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    // 统一返回默认表单，避免多次打开弹窗时残留上一次输入。
    getDefaultForm() {
      return {
        booking_id: "",
        microwave_moisture: "",
        measure_time: moment().format("YYYY-MM-DD HH:mm:ss")
      };
    },
    // 打开弹窗时只接收当前预约主键，其余字段允许人工补录。
    onOpen(bookingId) {
      this.form = this.getDefaultForm();
      this.form.booking_id = bookingId;
      this.dialogVisible = true;
    },
    // 关闭弹窗时重置校验状态，保证下次打开体验一致。
    onClose() {
      this.form = this.getDefaultForm();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    // 人工补录只在确认校验通过后提交，提交成功后刷新列表。
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$common.http({
          url: "/api/queue/admin/finish_microwave_moisture",
          data: this.form
        });
        this.$message.success("测水完成已补录");
        this.dialogVisible = false;
        this.$emit("ok");
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
